import "./IconSubsection.scss";

export const IconSubsection = () => {
  return <span className="icon-subsection"></span>;
};
